export default __webpack_public_path__ + "static/media/preco-justo.c81c16f6.png";